import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { FaArrowUp } from "react-icons/fa";

/**
 * ScrollToTop — resets the window scroll position to the top every
 * time the route changes and shows a floating "Back to Top" button.
 */
function ScrollToTop() {
  const { pathname } = useLocation();
  const [showButton, setShowButton] = useState(false);

  // Page change par top par le jao
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  // Scroll button show/hide
  useEffect(() => {
    const handleScroll = () => {
      setShowButton(window.scrollY > 300);
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Button click
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      {showButton && (
        <button
          onClick={scrollToTop}
          style={{
            position: "fixed",
            bottom: "25px",
            left: "25px",
            width: "55px",
            height: "55px",
            borderRadius: "50%",
            border: "none",
            background: "#0A5EB0",
            color: "#fff",
            fontSize: "20px",
            cursor: "pointer",
            boxShadow: "0 8px 20px rgba(0,0,0,.25)",
            zIndex: 9999,
            transition: "0.3s",
          }}
        >
          <FaArrowUp />
        </button>
      )}
    </>
  );
}

export default ScrollToTop;